import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export default function AdminCities() {
  const [cities, setCities] = useState([]);
  const [name, setName] = useState("");
  const [postal, setPostal] = useState("");
  const load = () => api.get("/admin/cities").then((r) => setCities(r.data));
  useEffect(() => { load(); }, []);
  const add = async () => {
    if (!name) return toast.error("Nom requis");
    try { await api.post("/admin/cities", { name, postal_code: postal, department: "28" });
      setName(""); setPostal(""); toast.success("Ajoutée"); load(); }
    catch { toast.error("Erreur"); }
  };
  const del = async (id) => { if (!confirm("Supprimer ?")) return; await api.delete(`/admin/cities/${id}`); toast.success("Supprimée"); load(); };
  return (
    <div>
      <h1 className="font-heading text-3xl font-bold">Villes</h1>
      <div className="mt-6 bg-white border border-slate-200 rounded-2xl p-4 flex gap-2">
        <Input placeholder="Nom" value={name} onChange={(e)=>setName(e.target.value)} data-testid="city-name-input"/>
        <Input placeholder="Code postal" value={postal} onChange={(e)=>setPostal(e.target.value)} data-testid="city-postal-input"/>
        <Button onClick={add} className="btn-shine text-white" data-testid="city-add-btn"><Plus size={16} className="mr-1"/> Ajouter</Button>
      </div>
      <div className="mt-4 bg-white border border-slate-200 rounded-2xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600"><tr><th className="p-3 text-left">Ville</th><th className="p-3 text-left">CP</th><th className="p-3"></th></tr></thead>
          <tbody>
            {cities.map((c) => (
              <tr key={c.id} className="border-t border-slate-100">
                <td className="p-3">{c.name}</td><td className="p-3 font-mono">{c.postal_code}</td>
                <td className="p-3 text-right"><button onClick={()=>del(c.id)} className="text-rose-600 hover:text-rose-800"><Trash2 size={16}/></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
